require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2018-06-29-treasure.json") })
        }
      }, "path---works-2018-06-29-treasure");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2018-06-29-treasure!./.cache/json/works-2018-06-29-treasure.json
// module id = 419
// module chunks = 231608221292675